function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DropdownList = /*#__PURE__*/function () {
  function DropdownList(element, dropdownSelected, dropdown) {
    _classCallCheck(this, DropdownList);

    this._element = element;
    this.dropdownSelected = dropdownSelected;
    this.boundEventHandler = this.select.bind(this);

    this._bind();
  }

  _createClass(DropdownList, [{
    key: "select",
    value: function select(e) {
      e.stopPropagation();
      var value = e.target.closest("vanilla-dropdown-value") || e.target.querySelector("vanilla-dropdown-value") || e.target;
      this.onChange(e, value.innerHTML.trim());
    }
  }, {
    key: "onChange",
    value: function onChange() {}
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "_bind",
    value: function _bind() {
      if (this._element != null) {
        this._element.addEventListener("click", this.boundEventHandler);
      }
    }
  }, {
    key: "_unbind",
    value: function _unbind() {
      if (this._element) {
        this._element.removeEventListener("click", this.boundEventHandler);
      }
    }
  }]);

  return DropdownList;
}();

export { DropdownList as default };